import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import { PeerToPeerListComponent } from '../peer-to-peer-list/peer-to-peer-list.component';

@Component({
  standalone:true,
  selector: 'app-manage-peer-to-peer-page',
  templateUrl: './manage-peer-to-peer-page.component.html',
  styleUrls: ['./manage-peer-to-peer-page.component.scss'],
  imports:[PeerToPeerListComponent,CoreModule]
})
export class ManagePeerToPeerPageComponent implements AfterViewInit, OnDestroy {
  
  @ViewChild('managePeerToPeerPage', { static: true }) peerToPeerPageRef: ElementRef;

  constructor() { }

  ngAfterViewInit () {
    const campaignStyles = window['documentManager'].createElement('link');
    campaignStyles.href = 'paybee-spa/styles.css?v=398';
    campaignStyles.rel = 'stylesheet';
    window['$'](this.peerToPeerPageRef.nativeElement).append(campaignStyles);
  }

  ngOnDestroy () {
    const $ = window['$'];
    $("#managePeerToPeerPage").hide();
    $("#managePeerToPeerPage").empty();
  }
}
